<template>
    <div id="section_header" :class="{ 'header_horse': (Boolean(horse) === true)}">
            <div class="container-fluid">
                <div class="row align-items-center">
                    <div class="col-md-auto" :class="{ 'col-12 order-3 order-md-2': (Boolean(horse) === true)}" v-if="(element && element.need_photo === true)">
                        <div v-if="element && element.need_photo === true" id="element_photo" class="mr-4">
                            <Photo :filename="element.filename" :img_id="element.id_photo" :alt="element.alt" v-if="element.type == 'photo' || element.type == ''"/>
                            <Picto :icon="element.icon" v-else/>
                        </div>
                    </div>
                    <div class="col" :class="{ 'order-md-3 order-2': (Boolean(horse) === true)}">
                        <template v-if="horse">
                            <div class="d-flex align-items-center">
                                <font-awesome-icon v-if="routeIcon" :icon="routeIcon" class="header-horse-icon mr-3" />
                                <div>
                                    <h1 class="mb-0 text-uppercase" v-if="title">{{ title }}</h1>
                                    <RecapHorseDedicated v-if="horse.use_dedicated_recap" ref="horse_recap" :horse="horse" :presence="presence" />
                                    <RecapHorse v-else ref="horse_recap" :horse="horse" :presence="presence" horse_readonly />
                                </div>
                                <div class="ml-auto" v-if="$slots.actions">
                                    <slot name="actions" />
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="d-flex align-items-center">
                                <h1 class="mb-0" v-if="title">
                                    <font-awesome-icon v-if="routeIcon" :icon="routeIcon" class="mr-2" />
                                    {{ title }}
                                </h1>
                                <div class="ml-auto" v-if="$slots.actions">
                                    <slot name="actions" />
                                </div>
                            </div>
                        </template>
                        <div id="subtitles" v-if="element && element.subtitle">
                            {{ element.subtitle }}
                        </div>
                    </div>
                </div>
                <Swiper v-if="swiper_tabs && swiper_tabs.length > 0" :tabs="swiper_tabs" :action="swiper_action" />
            </div>
    </div>
</template>

<script>
import Mvp from '@/assets/js/menus/mvp'
import Actes from '@/assets/js/menus/actes'
import Invoice from '@/assets/js/menus/invoice'
import Monte from '@/assets/js/menus/monte'
import Perfs from '@/assets/js/menus/perfs'
import Settings from '@/assets/js/menus/settings'
import Semence from '@/assets/js/menus/semence'

const allMenus = [].concat(Mvp, Actes, Monte, Invoice, Perfs, Semence, Settings)

export default {
    name: "HeaderTab",
    props: {
        title: { type: String, default: '' },
        icon: { type: Array, default: null },
        horse: { type: Object, default: null },
        presence: { type: Object, default: null },
        swiper_action: { type: Function, default: null },
        element: { type: Object, default: null },
        swiper_tabs: { type: Array, default: () => [] },
    },
    components: {
        Swiper: () => import('GroomyRoot/components/Swiper'),
        RecapHorse: () => import('GroomyRoot/components/Horse/RecapHorse'),
        RecapHorseDedicated: () => import('@/components/Dedicated/Horse/RecapHorse'),
        Photo: () => import('GroomyRoot/components/Header/Photo'),
        Picto: () => import('GroomyRoot/components/Header/Picto'),
    },
    computed: {
        routeIcon() {
            if (this.icon) return this.icon

            for (const record of this.$route.matched) {
                const match = allMenus.find(m => m.to && m.to.name === record.name)
                if (match) return match.icon
            }

            return null
        }
    }
}
</script>
